/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCartRequestCart
 */
export interface CreateCartRequestCart {
    /**
     * 
     * @type {string}
     * @memberof CreateCartRequestCart
     */
    shopifyCartId?: string;
}

/**
 * Check if a given object implements the CreateCartRequestCart interface.
 */
export function instanceOfCreateCartRequestCart(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCartRequestCartFromJSON(json: any): CreateCartRequestCart {
    return CreateCartRequestCartFromJSONTyped(json, false);
}

export function CreateCartRequestCartFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCartRequestCart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shopifyCartId': !exists(json, 'shopify_cart_id') ? undefined : json['shopify_cart_id'],
    };
}

export function CreateCartRequestCartToJSON(value?: CreateCartRequestCart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shopify_cart_id': value.shopifyCartId,
    };
}

